import Switch from '@mui/material/Switch';
import { CheckRecordActiveSwitchProps } from './types';
import useController from './useController';

export const CheckRecordActiveSwitch = (props: CheckRecordActiveSwitchProps) => {
  const { isActive, toggleActive } = useController(props);

  return <Switch checked={isActive} onChange={toggleActive} name="switch" />;
};

export default CheckRecordActiveSwitch;
